import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=b5eacb4c&scoped=true&"
var script = {}
import style0 from "./Account.vue?vue&type=style&index=0&id=b5eacb4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5eacb4c",
  null
  
)

export default component.exports